import { Toast, Dialog } from "vant";
import { getUserLocation } from "@/js_sdk/permission.js";
import store from "../store";
// 检查权限
export const checkPermission = (PermissionNames) => {
  const plus = window.plus;
  const pp = plus?.navigator.checkPermission(PermissionNames);
  switch (pp) {
    case "authorized":
      return true;
  }
  return false;
};

function gameraUpload(
  option = {
    title: "获取相册访问，以便您上传头像",
    tip: "请到设置中开启相机访问，以便选择资料上传",
    succeed: () => {},
  }
) {
  if (!window.plus) return;
  const plus = window.plus;
  const isCAMERA = checkPermission("CAMERA");
  const callBack = () => {
    var c = plus.camera.getCamera();
    c.captureImage(
      function (e) {
        store.commit("setToastPrmission", {
          show: false,
          title: "",
          msg: "",
        });
        plus.io.resolveLocalFileSystemURL(
          e,
          function (entry) {
            console.log(" entry.toLocalURL()", entry.toLocalURL());
            const path = entry.toLocalURL();
            var file = path.substr(path.lastIndexOf("/") + 1);
            fileUploader(path, file, option);
          },
          function (e) {
            Toast({
              position: "bottom",
              message: option.tip,
            });
          }
        );
      },
      function (s) {
        console.log("s", s);
        store.commit("setToastPrmission", {
          show: false,
          title: "",
          msg: "",
        });
        try {
          if (plus.os.name === "Android" && s.code === 12) {
            return;
          } else if (plus.os.name === "iOS" && s.code === -2) {
            return;
          }
          if (plus.os.name === "iOS" && s.message === "No filming permission") {
            Toast({
              position: "bottom",
              message: option.tip,
            });
          } else if (plus.os.name === "Android") {
            Toast({
              position: "bottom",
              message: option.tip,
            });
          }
        } catch (error) {
          Toast({
            position: "bottom",
            message: s.message,
          });
        }
      },
      {}
    );
  };
  if (!isCAMERA) {
    store.commit("setToastPrmission", {
      show: true,
      title: option.title,
      msg: option.tip,
    });
    callBack();
  } else {
    callBack();
  }
}

// 选择相册上传
function galleryUpload(
  option = {
    title: "获取相册访问，以便您上传头像",
    tip: "请到设置中开启相册访问，以便选择资料上传头像",
    succeed: () => {},
  }
) {
  if (!window.plus) return;
  const plus = window.plus;
  const isGALLERY = checkPermission("GALLERY");
  console.log("isGALLERY", isGALLERY);
  const callBack = () => {
    plus.gallery.pick(
      function (path) {
        var file = path.substr(path.lastIndexOf("/") + 1);
        fileUploader(path, file, option);
        store.commit("setToastPrmission", {
          show: false,
          title: "",
          msg: "",
        });
      },
      function (e) {
        console.log("e", e);
        store.commit("setToastPrmission", {
          show: false,
          title: "",
          msg: "",
        });
        try {
          if (plus.os.name === "Android" && e.code === 12) {
            return;
          } else if (plus.os.name === "iOS" && e.code === -2) {
            return;
          } else if (plus.os.name === "iOS" && e.code === 8) {
            Toast({
              position: "bottom",
              message: "请到设置打开相册访问权限",
            });
          } else if (plus.os.name === "Android") {
            Toast({
              position: "bottom",
              message: "请到设置打开相册访问权限",
            });
          }
        } catch (error) {
          store.commit("setToastPrmission", {
            show: false,
            title: "",
            msg: "",
          });
          Toast({
            position: "bottom",
            message: "请到设置打开相册访问权限",
          });
        }
      },
      {
        filter: "image",
      }
    );
  };
  if (!isGALLERY) {
    store.commit("setToastPrmission", {
      show: true,
      title: option.title,
      msg: option.tip,
    });
    callBack();
    // Dialog.confirm({
    //   title: "授权提示",
    //   message: option.title,
    // }).then(() => {
    //   callBack();
    // });
  } else {
    callBack();
  }
}

// 选择相册上传
async function getUserLocationModal(
  option = {
    title: "定位权限使用说明",
    tip: "展示周边门店、客流等数据",
    succeed: () => {},
  }
) {
  if (!window.plus) {
    store.commit("setCoordinate", "22.52413233,113.937094");
    store.commit("setCityName", "深圳市");
    store.commit("setPageCityMomory", 'clear');
    option.succeed({
      lat: 22.52413233,
      lng: 113.937094,
      cityName: "深圳市",
    });
    return
  };
  const isGALLERY = checkPermission("LOCATION");
  // 未授权
  if (!isGALLERY) {
    store.commit("setToastPrmission", {
      show: true,
      title: option.title,
      msg: option.tip,
    });
    const latLng = await getUserLocation(true);
    store.commit("setToastPrmission", {
      show: false,
      title: "",
      msg: "",
    });

    if (option.succeed) option.succeed(latLng);

    // toast.clear();
    // Dialog.confirm({
    //   title: "授权提示",
    //   message: option.title,
    // }).then(async () => {
    //   const latLng = await getUserLocation(true);
    //   if (option.succeed) option.succeed(latLng);
    // });
  }
  // 已授权
  else {
    store.commit("setToastPrmission", {
      show: false,
      title: "",
      msg: "",
    });
    const latLng = await getUserLocation(true);
    if (option.succeed) option.succeed(latLng);
  }
}

// 上传图片到华为云
function fileUploader(path, file, option) {
  if (!window.plus) return;
  const plus = window.plus;
  const url = process.env.VUE_APP_BASE_API + "/api/v1/common/upload";
  const uploader = plus.uploader.createUpload(
    url,
    {
      method: "POST",
    },
    async function (up, state) {
      var xhrData = JSON.parse(up.responseText);
      if (state == 200) {
        const res = xhrData;
        const download_url = res.data.download_url;
        if (option.succeed) option.succeed(download_url);
      } else {
        Toast("上传图片失败 - " + state);
      }
    }
  );
  uploader.addData("key", file);
  uploader.addData("token", "token"); //添加上传参数  token必填
  uploader.addFile(path, {
    key: "file",
  });
  uploader.start();
}

export { galleryUpload, gameraUpload, getUserLocationModal };
